
// src/actions/divisions-settings.js
import api from './gamba-api'
import { emitAlertMessage } from './alert-message'
import {reloadDivision} from './divisions.js'
export const OPEN_DIVISION_SETTINGS_PAGE = "OPEN_DIVISION_SETTINGS_PAGE"


export function openDivisionSettingsPage(name) {
  return {
    type: OPEN_DIVISION_SETTINGS_PAGE,
    name
  }
}

export const CLOSE_DIVISION_SETTINGS_PAGE = "CLOSE_DIVISION_SETTINGS_PAGE"

export function closeDivisionSettingsPage() {
  return {
    type: CLOSE_DIVISION_SETTINGS_PAGE,
  }
}

export const UPDATE_DIVISION = "UPDATE_DIVISION"
export const UPDATE_DIVISION_REQUESTED = "UPDATE_DIVISION_REQUESTED"
export const UPDATE_DIVISION_COMPLETED = "UPDATE_DIVISION_COMPLETED"
export const UPDATE_DIVISION_FAILED = "UPDATE_DIVISION_FAILED"

export function updateDivision(division_id, name, access_type, uploadable_file_id, crop) {
  
  return function(dispatch) {
    dispatch(updateDivisionRequested({}));
    return api.put(`/divisions/${division_id}`, { name, access_type, uploadable_file_id, crop })
        .then((results)=> {
          dispatch(updateDivisionCompleted(results))
          dispatch(reloadDivision(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateDivisionFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateDivisionRequested() {
    return {
      type: UPDATE_DIVISION_REQUESTED
    }
}

export function updateDivisionCompleted(results) {
  return {
    type: UPDATE_DIVISION_COMPLETED,
    results,
  }
}

export function updateDivisionFailed(error) {
  return {
    type: UPDATE_DIVISION_FAILED,
    error,
  }
}



export const CREATE_DIVISION = "CREATE_DIVISION"
export const CREATE_DIVISION_REQUESTED = "CREATE_DIVISION_REQUESTED"
export const CREATE_DIVISION_COMPLETED = "CREATE_DIVISION_COMPLETED"
export const CREATE_DIVISION_FAILED = "CREATE_DIVISION_FAILED"


export function createDivisionRequested() {
  return {
    type: CREATE_DIVISION_REQUESTED
  }
}

export function createDivision(name, access_type, uploadable_file_id, crop) {
  return function(dispatch) {
    //dispatch(createDivisionRequested())
    return dispatch(createDivisionCompleted(results));
    return api.post(`/divisions`, { name, access_type, uploadable_file_id, crop})
        .then((results)=> {
          dispatch(createDivisionCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(createDivisionFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function createDivisionCompleted(results) {
  return {
    type: CREATE_DIVISION_COMPLETED,
    results,
  }
}

export function createDivisionFailed(error) {
  return {
    type: CREATE_DIVISION_FAILED,
    error,
  }
}


// WEBPACK FOOTER //
// ./src/actions/division-settings.js